import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HscodeService {

  hsCodeTypeId = new Subject<any>();

  constructor() { }

  setHsCode(hsCodeTypeId: any) {
    localStorage.setItem('hsCodeTypeId', JSON.stringify(hsCodeTypeId));
    this.hsCodeTypeId.next(hsCodeTypeId);
  }

  getHsCodet() {
    return this.hsCodeTypeId.asObservable();
  }
}
